import { useQuery } from '@tanstack/react-query';

import { $apiV2 } from 'modules/global';

import { IFeedbacks, proConst } from '..';

export const getFeedbacks = async () => {
  const { data } = await $apiV2.get<{ data: IFeedbacks[] }>('/user-feedback/view');

  return { feedbacks: data?.data };
};

export const useFeedbacks = () => {
  const { data, ...args } = useQuery({
    queryKey: [proConst.queryKeys.FEEDBACKS],
    queryFn: getFeedbacks
  });

  return { ...data, ...args };
};
